// eslint-disable-next-line import/no-cycle
import { handleOrganisationRoutes } from '@/helpers/router';
import { permissionActionName, permissionSubjectName, PermissionSuffix } from '@/service/api/core/enums/permission';
import { PermissionEnum } from '@vini-wine/core-enums';
export default [
    {
        path: '/organisation/:orgUuid/integrations/wine-labs',
        name: 'integrations-wine-labs-index',
        component: () => import('@/views/organisation/integrations/wine-labs/Index.vue'),
        meta: {
            resource: permissionSubjectName(PermissionEnum.INTEGRATION_WINE_LABS__VIEW, PermissionSuffix.USER_ORGANISATION),
            action: permissionActionName(PermissionEnum.INTEGRATION_WINE_LABS__VIEW),
            pageTitle: 'pageTitles.wineLabsIntegration.title',
            disableScrollBehaviour: true,
            breadcrumb: [
                {
                    text: 'breadcrumbs.integrations.wineLabs.integrations',
                },
                {
                    text: 'breadcrumbs.integrations.wineLabs.wineLabs',
                    active: true,
                },
            ],
        },
        beforeEnter: (to, from, next) => {
            handleOrganisationRoutes(to);
            next();
        },
    },
];
